import type { FormControlLabelProps } from '@mui/material';
import { ATLAS_LENS_COLORS } from '../Form/formFieldSpec';
import { ONBOARDING_STEP2_FIGMA } from './onboardingFigmaSpec';

const { typography } = ONBOARDING_STEP2_FIGMA;

/**
 * FormControlLabel checkbox rows — use a string `label` plus these slotProps so MUI wraps
 * the label with `.MuiFormControlLabel-label` and Atlas Lens applies checkbox–label spacing
 * (`.MuiCheckbox-root + .MuiFormControlLabel-label`).
 */
export function onboardingCheckboxLabelSlotProps(): NonNullable<FormControlLabelProps['slotProps']> {
  return {
    typography: {
      component: 'span',
      sx: {
        fontSize: typography.textMd.fontSize,
        lineHeight: `${typography.textMd.lineHeight}px`,
        letterSpacing: typography.textMd.letterSpacing,
        fontWeight: typography.textMd.fontWeight,
        color: ATLAS_LENS_COLORS.typeDefault,
      },
    },
  };
}
